import * as React from "react";
import { memo } from "react";
import "./movieItemViewStyles.css";
import { useFocusable } from "../../../utils/Helpers";
import { MovieTagView } from "./MovieTagView";
import { MoviePoster } from "./MoviePoster";
import { MovieLabelView } from "./MovieLabelView";
export var MovieItemView = memo(function (_a) {
    var focusRaw = _a.focusRaw, movie = _a.movie, _b = _a.active, active = _b === void 0 ? true : _b, onMoviePress = _a.onMoviePress, onKeyBack = _a.onKeyBack;
    var ref = useFocusable({
        group: focusRaw[0],
        index: focusRaw[1],
        onKeyDown: function () { return onMoviePress(movie); },
        onKeyBack: onKeyBack,
    });
    return (React.createElement("div", { tabIndex: 0, ref: ref, className: "movie-card-container" },
        React.createElement(MoviePoster, { url: movie.poster, active: active }),
        React.createElement("p", { className: "movie-title" }, movie.name),
        React.createElement("p", { className: "rating" }, movie.mpaaRating),
        React.createElement(MovieTagView, { movie: movie }),
        React.createElement(MovieLabelView, { movie: movie })));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/movie/MovieItemView.tsx
// module id = 50
// module chunks = 1